import mixpanel from "mixpanel-browser"

let initialized = false

// When a document is loaded with `?noActions` (e.g. the homepage embeds a TN
// profile in an iframe as a non-interactive preview), its events should still be
// sent — but under a custom, prefixed name so they're clearly separate from real
// profile metrics and never pollute them. Every event passes through this single
// choke point, so the prefix is applied consistently (video player, modals, etc.).
// The flag is evaluated once and cached (sticky), surviving any in-iframe client
// navigation that drops the param. The parent page runs a separate bundle
// instance, so its events are never prefixed.
const PREVIEW_EVENT_PREFIX = "[Home Iframe] "
let iframePreviewMode = null
function isIframePreview() {
  if (iframePreviewMode === null) {
    try {
      iframePreviewMode =
        typeof window !== "undefined" &&
        new URLSearchParams(window.location.search).has("noActions")
    } catch (e) {
      iframePreviewMode = false
    }
  }
  return iframePreviewMode
}

// Prefix the event name when running inside the home iframe preview.
function eventNameFor(name) {
  return isIframePreview() ? `${PREVIEW_EVENT_PREFIX}${name}` : name
}

function getCrossSubdomainCookieDomain() {
  const nodeEnv = process.env.GATSBY_NODE_ENV
  if (nodeEnv === "prod") return ".trytendercare.com"
  if (nodeEnv === "dev") return ".netlify.app"
  return undefined
}

export function initMixpanel() {
  if (typeof window === "undefined" || initialized) return initialized
  const token = process.env.GATSBY_MIXPANEL_TOKEN
  if (!token) return false
  try {
    const cookieDomain = getCrossSubdomainCookieDomain()
    const isHttps =
      typeof window !== "undefined" && window.location?.protocol === "https:"
    mixpanel.init(token, {
      ...(cookieDomain && {
        cookie_domain: cookieDomain,
        persistence: "cookie",
        cross_subdomain_cookie: true,
      }),
      secure_cookie: isHttps,
    })
    initialized = true
  } catch (e) {
    // ignore init failures (e.g. ad-blockers, invalid token)
  }
  return initialized
}

function safeTrack(...args) {
  try {
    if (typeof window === "undefined" || !initialized) return
    mixpanel.track(...args)
  } catch (e) {
    // avoid third-party errors (e.g. before_track when config undefined) breaking the app
  }
}

export function trackEvent(eventName, properties = {}) {
  if (typeof window === "undefined") return
  const name = eventNameFor(eventName)
  console.info("TRACK", name, properties)
  initMixpanel()
  safeTrack(name, properties)
}

/**
 * Record a page/screen view. Call on route or search params change.
 * Sends "Landing Web Page Viewed" with screen_name, referrer (if any), and search params (e.g. utm_*).
 */
export function screen(pathname, properties = {}) {
  if (typeof window === "undefined") return
  console.info("SCREEN", pathname, properties || "")
  initMixpanel()
  safeTrack(eventNameFor("Landing Web Page Viewed"), {
    screen_name: pathname,
    ...properties,
  })
}
